import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { getCityGenericNameFromNumber } from "Utils/Common";
import { StringValue } from "./StringValue";
import { StringMap } from "./StringMap";
import { StringArray } from "./StringArray";

export default function(props) {
  const { task } = props;

  let skills = Object.keys(task.taskstatusdetail.skills).map((key) => {
    return task.taskstatusdetail.skills[key];
  });

  if (!skills) {
    skills = [];
  }

  return (
    <TaskletCard title="Enrolling skills">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringMap
          label={"Selected Heroes"}
          valueMap={task.taskstatusdetail.selectedheroes}
          valueParser={(k, v) =>
            v.map((item) => {
              if (!item.selected) {
                return null;
              }
              return (
                <div className="infovalue" style={{ fontSize: "15px" }}>
                  {item.name}({getCityGenericNameFromNumber(k)})
                </div>
              );
            })
          }
        />
        <StringArray label={"Selected Skills:"} array={skills} />
        <StatusSection task={task} />
        <StringValue
          label={"Currently running:"}
          value={task.taskstatusdetail.currentlyrunning}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
